import { Components } from '@/api/generated/api';
import { EConfirmDialogResult, useConfirmDialog } from '@/composables/useConfirmDialog';
import { hasGradingsForStudent } from 'common/utils/performance.assessment.entry.utils';
import { useI18n } from 'vue-i18n';

export const usePerformanceAssessmentEntryDuplicateGradingsConfirm = (): {
  confirmIncludeGradings: (
    entry: Components.Schemas.PerformanceAssessmentEntryDto,
    studentIds: number[],
  ) => Promise<boolean | null>;
} => {
  const { confirmWithResult } = useConfirmDialog();
  const { t } = useI18n();

  const confirmIncludeGradings = async (
    entry: Components.Schemas.PerformanceAssessmentEntryDto,
    studentIds: number[],
  ): Promise<boolean | null> => {
    if (!studentIds.some((studentId) => hasGradingsForStudent(entry, studentId))) return false;

    const result = await confirmWithResult({
      title: t('performanceAssessmentEntry.confirmDuplicateGradings.title'),
      description: t('performanceAssessmentEntry.confirmDuplicateGradings.description'),
      confirmButtonLabel: t('performanceAssessmentEntry.confirmDuplicateGradings.confirmButtonLabel'),
      declineButtonLabel: t('performanceAssessmentEntry.confirmDuplicateGradings.declineButtonLabel'),
      theme: 'primary',
      size: 'lg',
      buttonAlignment: 'between',
      declineOnClose: false,
    });
    if (result === EConfirmDialogResult.Close) return null;
    return result === EConfirmDialogResult.Confirm;
  };

  return {
    confirmIncludeGradings,
  };
};
